import LiquidacaoFiltro from '../../produto/spa/liquidacao-contrato/LiquidacaoFiltro';

export default LiquidacaoFiltro;
